
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { InventoryKind__get_Key } from "../Shared/InventoryStates.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "./Badge.js";

export const inventoryTypeColors = {
    Consumable: "#EA580C",
    Set: "#A855F7",
    Tool: "#14BC9C",
    ToolWithQuantity: "#2563EB",
};

export function inventoryTypeColor(inventoryType) {
    switch (inventoryType.tag) {
        case 2:
            return inventoryTypeColors.ToolWithQuantity;
        case 1:
            return inventoryTypeColors.Set;
        case 3:
            return inventoryTypeColors.Consumable;
        default:
            return inventoryTypeColors.Tool;
    }
}

export function inventoryTypeTranslationKey(inventoryType) {
    switch (inventoryType.tag) {
        case 2:
            return "general.tool_with_quantity";
        case 1:
            return "general.set";
        case 3:
            return "general.consumable";
        default:
            return "general.tool";
    }
}

export function inventoryTypeLabel(t, inventoryType) {
    return t(inventoryTypeTranslationKey(inventoryType));
}

export function inventoryTypeBadgeTestId(inventoryType) {
    return concat("inventory-type-badge-", ...InventoryKind__get_Key(inventoryType));
}

export function InventoryTypeBadge(props) {
    const patternInput = useTranslation();
    return createElement(Badge, {
        Color: inventoryTypeColor(props.InventoryType),
        Label: inventoryTypeLabel(patternInput[0], props.InventoryType),
        TestId: inventoryTypeBadgeTestId(props.InventoryType),
    });
}

